import { AxiosInstance } from 'axios'
import { Identifier } from './_types'

export type TreatmentReference = {
  id: number
  reference: string
  treatmentId: number
}

export type TreatmentDosageLme = {
  id: number
  cids: Array<Identifier & { code?: string }>
  showLmeInAttendance: boolean
  applicableFirstPrescription: boolean
  firstPrescriptionMonth1: number
  firstPrescriptionMonth2: number
  firstPrescriptionMonth3: number
  firstPrescriptionMonth4: number
  firstPrescriptionMonth5: number
  firstPrescriptionMonth6: number
  applicableMaintenancePrescription: boolean
  maintenancePrescriptionMonth1: number
  maintenancePrescriptionMonth2: number
  maintenancePrescriptionMonth3: number
  maintenancePrescriptionMonth4: number
  maintenancePrescriptionMonth5: number
  maintenancePrescriptionMonth6: number
  anamnesis?: string
}

export type TreatmentDosage = {
  id: number
  minAge?: number
  maxAge?: number
  minWeight?: number
  maxWeight?: number
  firstPrescription?: string
  maintenancePrescription?: string
  treatmentId: number
  treatmentDosageLme?: TreatmentDosageLme
}

export type TreatmentPrescription = {
  id: number
  exams: Identifier[]
  firstPrescription: boolean
  maintenancePrescription: boolean
  treatmentId: number
}

export type TreatmentExhibitionRule = {
  id: number
  diseaseId: number
  slug: string
  type: 'INCLUSION' | 'EXCLUSION'
  label: string
  condition: Record<string, unknown>
}

export type Treatment = {
  id: number
  disease: Identifier
  medicine: Identifier & {
    category: Identifier & { shortName?: string }
  }
  guidelines?: string
  details?: string
  availablePublicMedicalCare: boolean
  availablePrivateMedicalCare: boolean
  prescriptions: TreatmentPrescription[]
  references: TreatmentReference[]
  dosages: TreatmentDosage[]
  exhibitionConfig?: Record<string, unknown>
  exhibitionRules: TreatmentExhibitionRule[]
}

export function treatmentEndpoints(apiClient: AxiosInstance) {
  return {
    listByDisease(diseaseId: number, mini = false): Promise<{ items: Treatment[]; total: number }> {
      return apiClient.get(`treatment/disease/${diseaseId}`, { params: { mini } })
    },
  }
}
